module.exports = __webpack_public_path__ + "img/agromat.9a609e04.webp";